import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";

export default function Advertisement() {
  const { showPage, setShowPage, accessObject } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [showPrePage] = React.useState(10);
  const [buttonLoader, setbuttonLoader] = React.useState(false);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const updateShowPerpagevalue = (value) => {
    // setShowPrePage(value);
    // setPagination({ start: 0, end: value });
  };

  const AdSettingsSchema = Yup.object().shape({
    platformType: Yup.number().required("Platform Type is required"),
    bannerId: Yup.string().required("Banner ID is required"),
    interstitialId: Yup.string().required("Interstitial ID is required"),
    rewardId: Yup.string().required("Reward ID is required"),
    nativeId: Yup.string().required("Native ID is required"),
    appOpenId: Yup.string().required("App Open ID is required"),
  });

  React.useEffect(() => {
    getBranch();
  }, []);

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/advertisement/get-advertisement`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);

        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    setRowValue(item);
    setOpenValue(2);
  };

  const openAddTournament = (value) => {
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
  };

  const updateTournament = (value) => {
    console.log("updateTournament value :::", value);

    axios
      .patch(
        `${API_URL}/api/admin/advertisement/update-advertisement/${rowValue._id}`,
        value
      )
      .then((res) => {
        console.log("updateTournament update :::", res.data);
        if (res.data.status) {
          successEdit(res.data.message);
          setbuttonLoader(false);
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        setbuttonLoader(false);
        console.log("updateTournament err :::", err);
        warningAlert();
      });
  };

  const addNewTournament = (value) => {
    console.log("addNewTournament ---", value);

    axios(`${API_URL}/api/admin/advertisement/add-advertisement`, {
      method: "POST",
      credentials: "include",
      data: value,
    })
      .then((result) => {
        console.log("addNewTournament result :::", result.data);
        if (result.data.status) {
          setbuttonLoader(false);
          successAdd();
        } else {
          warningAlert();
          setbuttonLoader(false);
        }
      })
      .catch((err) => {
        console.log("addNewTournament err :::", err);
        setbuttonLoader(false);
        warningAlert();
      });
  };

  const warningWithConfirmMessage = (e) => {
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert"
        btnSize="md"
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete this advertisement record. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">The advertisement record has been deleted successfully.</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    console.log("e===>", e._id);
    axios
      .delete(
        `${API_URL}/api/admin/advertisement/delete-advertisement/${e._id}`
      )
      .then((res) => {
        if (res.data.status) {
          successDeleted();
        } else {
          warningAlert();
        }
      });
  };

  const successAdd = () => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">The advertisement record has been added successfully.</p>
      </SweetAlert>
    );
  };

  const successEdit = (msg) => {
    setAlert(
      <SweetAlert
        success
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Success!</div>
        <p className="premium-alert-text">{msg || "The advertisement record has been updated successfully."}</p>
      </SweetAlert>
    );
  };

  const warningAlert = () => {
    setAlert(
      <SweetAlert
        warning
        onConfirm={() => setAlert(null)}
        customClass="premium-alert" btnSize="md" title=""
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Wait!</div>
        <p className="premium-alert-text">Something went wrong. Please try again later.</p>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div class="content p-3 ">
          <div className="card p-3">
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  platformType: rowValue ? rowValue?.platformType : "",
                  bannerId: rowValue ? rowValue?.bannerId : "",
                  interstitialId: rowValue ? rowValue?.interstitialId : "",
                  rewardId: rowValue ? rowValue?.rewardId : "",
                  nativeId: rowValue ? rowValue?.nativeId : "",
                  appOpenId: rowValue ? rowValue?.appOpenId : "",
                }}
                validationSchema={AdSettingsSchema}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  console.log(values);

                  if (openValue === 1) {
                    console.log("update formik value :::", openValue);
                    addNewTournament(values);
                  }
                  if (openValue === 2) {
                    console.log("update formik value :::", openValue);
                    updateTournament(values);
                  }
                }}
              >
                {({ touched, errors, isSubmitting, values, setFieldValue }) => (
                  console.log("values::: ", values),
                  (
                    <div>
                      <Form>
                        <div className="form-group">
                          <label className="mt-3">Platform Type</label>

                          <Field
                            as="select"
                            name="platformType"
                            className={`mt-2 form-control`}
                          >
                            <option value="">Select Platform Type</option>
                            <option value={0}>android</option>
                            <option value={1}>ios</option>
                          </Field>

                          <ErrorMessage
                            component="div"
                            name="platformType"
                            className="invalid-feedback"
                          />
                        </div>

                        <div className="form-group">
                          <label className="mt-3">Banner ID</label>
                          <Field
                            type="text"
                            name="bannerId"
                            placeholder="Enter Banner ID..."
                            className={`mt-2 form-control ${touched.bannerId && errors.bannerId
                                ? "is-invalid"
                                : ""
                              }`}
                          />
                          <ErrorMessage
                            component="div"
                            name="bannerId"
                            className="invalid-feedback"
                          />
                        </div>

                        <div className="form-group">
                          <label className="mt-3">Interstitial ID</label>
                          <Field
                            type="text"
                            name="interstitialId"
                            placeholder="Enter Interstitial ID..."
                            className={`mt-2 form-control ${touched.interstitialId && errors.interstitialId
                                ? "is-invalid"
                                : ""
                              }`}
                          />
                          <ErrorMessage
                            component="div"
                            name="interstitialId"
                            className="invalid-feedback"
                          />
                        </div>

                        <div className="form-group">
                          <label className="mt-3">Reward ID</label>
                          <Field
                            type="text"
                            name="rewardId"
                            placeholder="Enter Reward ID..."
                            className={`mt-2 form-control ${touched.rewardId && errors.rewardId
                                ? "is-invalid"
                                : ""
                              }`}
                          />
                          <ErrorMessage
                            component="div"
                            name="rewardId"
                            className="invalid-feedback"
                          />
                        </div>

                        <div className="form-group">
                          <label className="mt-3">Native ID</label>
                          <Field
                            type="text"
                            name="nativeId"
                            placeholder="Enter Native ID..."
                            className={`mt-2 form-control ${touched.nativeId && errors.nativeId
                                ? "is-invalid"
                                : ""
                              }`}
                          />
                          <ErrorMessage
                            component="div"
                            name="nativeId"
                            className="invalid-feedback"
                          />
                        </div>

                        <div className="form-group">
                          <label className="mt-3">App Open ID</label>
                          <Field
                            type="text"
                            name="appOpenId"
                            placeholder="Enter App Open ID..."
                            className={`mt-2 form-control ${touched.appOpenId && errors.appOpenId
                                ? "is-invalid"
                                : ""
                              }`}
                          />
                          <ErrorMessage
                            component="div"
                            name="appOpenId"
                            className="invalid-feedback"
                          />
                        </div>

                        <button
                          style={{ width: "100px" }}
                          type="submit"
                          className="btn btn-primary btn-block mt-4 mr-2"
                          disabled={buttonLoader}
                        >
                          <div
                            className="d-flex"
                            style={{
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              className="d-flex"
                              style={{
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <b>Submit</b>
                            </div>
                            {buttonLoader && (
                              <div>
                                <div
                                  class="spinner-border ml-2 mt-1"
                                  role="status"
                                  style={{ height: "20px", width: "20px" }}
                                ></div>
                              </div>
                            )}
                          </div>
                        </button>
                      </Form>
                    </div>
                  )
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div class="card ">
            {/* <div
              class="pl-4 pr-4 pt-4"
              style={{ display: "flex", justifyContent: "space-between" }}
                          > */}
            <div className="row pl-4 pr-4 pt-4">
              <div className="col-12 col-md-5">
                {/* {accessObject?.addRoomTier === true && ( */}
                <button
                  style={{ width: "118px" }}
                  onClick={() => {
                    openAddTournament(1);
                  }}
                  type="button"
                  className="btn btn-primary btn-block "
                >
                  <AddIcon />
                  Add New
                </button>
                {/* )} */}
              </div>
              <div className="col-12 col-md-7">
                <h3 class="card-title">
                  <b>Advertisement</b>
                </h3>
              </div>
            </div>

            <div class="card-body" style={{ overflow: "scroll" }}>
              <table id="" class="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th style={{ textWrap: "nowrap" }}>platform Type</th>
                    {/* <th style={{ textWrap: "nowrap" }}>Banner Id</th>
                    <th style={{ textWrap: "nowrap" }}>Interstitial Id</th>
                    <th style={{ textWrap: "nowrap" }}>Reward Id</th>
                    <th style={{ textWrap: "nowrap" }}>Native Id</th>
                    <th style={{ textWrap: "nowrap" }}>App Open Id</th> */}

                    {/* {(accessObject?.editRoomTier === true ||
                      accessObject?.deleteRoomTier === true) && ( */}
                    <th style={{ textAlign: "center" }}>Action</th>
                    {/* )} */}
                  </tr>
                </thead>
                {/* {accessObject?.getRoomTier === true ? ( */}
                <tbody>
                  {!loader ? (
                    <>
                      {tableData.length > 0 ? (
                        <>
                          {tableData
                            ?.slice(pagination.start, pagination.end)
                            .map((item, index) => (
                              <>
                                <tr key={index}>
                                  <td>{index + 1 + pagination.start}</td>
                                  <td style={{ textWrap: "nowrap" }}>
                                    {item.platformType === 0
                                      ? "android"
                                      : "ios"}
                                  </td>
                                  {/* <td style={{ textWrap: "nowrap" }}>
                                    {item.bannerId}
                                  </td>
                                  <td style={{ textWrap: "nowrap" }}>
                                    {item.interstitialId}
                                  </td>
                                  <td style={{ textWrap: "nowrap" }}>
                                    {item.rewardId}
                                  </td>
                                  <td style={{ textWrap: "nowrap" }}>
                                    {item.rewardId}
                                  </td>
                                  <td style={{ textWrap: "nowrap" }}>
                                    {item.appOpenId}
                                  </td> */}
                                  {/* {(accessObject?.editRoomTier === true ||
                                    accessObject?.deleteRoomTier === true) && ( */}
                                  <td className="justify-content-evenly ">
                                    <div className="d-flex">
                                      {/* {accessObject?.editRoomTier ===
                                          true && ( */}
                                      <EditIcon
                                        className="mr-3 courser"
                                        onClick={() => clickEditButton(item)}
                                      />
                                      {/* )} */}
                                      {/* {accessObject?.deleteRoomTier ===
                                          true && ( */}
                                      <ClearIcon
                                        className="courser text-danger"
                                        onClick={() =>
                                          warningWithConfirmMessage(item)
                                        }
                                      />
                                      {/* )} */}
                                    </div>
                                  </td>
                                  {/* )} */}
                                </tr>
                              </>
                            ))}
                        </>
                      ) : (
                        <EmptyState colSpan={3} />
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </tbody>
                {/* ) : (
                <>
                  <tr
                    style={{ backgroundColor: "rgba(0,0,0,.05)" }}
                    className="text-center"
                  >
                    <td colSpan={6}>
                      <h5>Access Denied</h5>
                    </td>
                  </tr>
                </> */}
                {/* )} */}
              </table>
              <div className="mt-4">{loader && <Loader />}</div>
            </div>
            {tableData.length !== 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={tableData.length}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
